import { Scroll } from "gls/lib";
import { action, makeObservable, observable } from "mobx";
import React from "react";
import { RootStore } from "./RootStore";
import { ErrorResponseDto } from "api/config/ErrorResponseDto";

export class LayoutStore {
  root: RootStore;
  pageTitle: React.ReactNode = "";
  pageError: ErrorResponseDto | null = null;
  scroll: Scroll = "hidden";
  pageSubTitle: React.ReactNode = ""
  itemsCount: number = 0

  constructor(root: RootStore) {
    this.root = root;
    makeObservable(this, {
      pageTitle: observable,
      itemsCount: observable,
      pageSubTitle: observable,
      pageError: observable,
      scroll: observable,

      setPageTitle: action.bound,
      setItemCount: action.bound,
      setPageError: action.bound,
      setScroll: action.bound,
      reset: action.bound
    });
  }

  reset() {
    this.pageTitle = ""
    this.pageError = null
    this.pageSubTitle = ""
    this.itemsCount = 0
  }

  setPageTitle(value: React.ReactNode) {
    this.pageTitle = value;
  }

  setPageSubTitle(value: React.ReactNode) {
    this.pageSubTitle = value;
  }

  setItemCount(count: number, itemCountTitle: string) {
    this.itemsCount = count;
    this.pageSubTitle = `# ${this.itemsCount.toString().padStart(2, '0')} ${itemCountTitle}`
  }

  setPageError(value: ErrorResponseDto | null) {
    this.pageError = value
  }

  setScroll(value: Scroll) {
    this.scroll = value;
  }
}
